let expanded = false;
const options = document.getElementById("selectOptions");
const customSelect = document.getElementById("customSelect");
const selectContainer = document.getElementById('multiSelectContainer');

function showCheckboxes() {
  if (!expanded) {
    options.style.display = "block";
    expanded = true;
  } else {
    options.style.display = "none";
    expanded = false;
  }
}

function updateLabel() {
  const toggle = customSelect.querySelector('button');

  const selected = checks.filter(check => check.checked == true);

  if (selected.length >= 2) {
    toggle.innerHTML =  "Multiple states selected";
  } else if (selected.length == 1) {
    toggle.innerHTML = selected[0].dataset.name;
  } else {
    toggle.innerHTML = "All states";
  }
}

if (customSelect){
  customSelect.addEventListener('click', ()=> {
    showCheckboxes();
  });
}

//listener on last checkbox to close when tabbign out
const checks = customSelect ? Array.from(options.querySelectorAll('input')) : [];
const lastCheck = checks.length ? checks[checks.length - 1] : null;

if (lastCheck) {

  lastCheck.addEventListener('keydown', (e) => {
    if (!event.shiftkey && e.keyCode === 9 ) {
            showCheckboxes();

      }
  });
}

checks.forEach((check) => {
  check.addEventListener('click', () => {
    updateLabel();
  })
})


//global listener for click out of custom select
const pageContainer = document.getElementById('container');
if (pageContainer){
  pageContainer.addEventListener('click', (e) => {
    const clickedInside = selectContainer.contains(e.target);
    if (!clickedInside) {
      options.style.display = "none";
      expanded = false;
    }
  });
}

if (customSelect) {
  updateLabel();
}


// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/multiselect.js